import { ICountry } from '@/api/common';
import { Country } from '@/helpers/conf';

export const API_PATH = '/api';

export const PAYMENTS_REDIRECT_ROUTES = {
  SUCCESS: '/deposit/success',
  FAILURE: '/deposit/failure',
  PENDING: '/deposit/pending',
  SUPPORT: '/',
};

export const PUBLIC_URL = 'https://www.levelupcasino.com';

export const ONE_SIGNAL_APP_IDS = {
  MAIN: '1f90e576-ce9c-4270-997c-788b16e79c6a',
  MIRROR_2: 'b9fb74f9-1603-4a27-ac8f-25ac84146484',
  MIRROR_8: '8b866b28-37af-4bff-b9fc-851a72f26e40',
  MIRROR_10: 'd440edab-d108-40ff-a27d-98c55bb67624',
  // AU
  MIRROR_30: '6cd3af35-e132-41af-a902-2ffa19f23fc4',
  MIRROR_35: '40b410b6-4f75-4ade-ab12-3ee13ed9d7fc',
};

export const DOMAINS = {
  MAIN: 'levelupcasino.com',
  MAIN_IO: 'levelup.casino',
  DEV: 'next.lv01-dev.k8s.levelupcasino2.com',
  DEV_2: 'webapp-lv01-dev.levelupcasino2.com',
  LOCAL: 'localhost',
  MIRROR_1: 'levelupcasino1.com',
  MIRROR_2: 'levelupcasino2.com',
  MIRROR_3: 'levelupcasino3.com',
  MIRROR_4: 'levelupcasino4.com',
  MIRROR_5: 'levelupcasino5.com',
  MIRROR_7: 'levelupcasino7.com',
  MIRROR_8: 'levelupcasino8.com',
  MIRROR_10: 'levelupcasino10.com',
  MIRROR_30: 'levelupcasino30.com',
  MIRROR_35: 'levelupcasino35.com',
  OTHER: 'levelup.casino',
  PROMO: 'promo.levelupcasino.com',
};

export const REQUEST_TIMEOUT = 60;
export const CACHE_REVALIDATE_TIMEOUT = 0;

export const AUTH_RATE_LIMIT_LOGIN_ATTEMPTS = 10;
export const AUTH_RATE_LIMIT_LOGIN_ATTEMPTS_TTL = 10800000;

export const X_SELL_USER_API = 'https://v1.xsell-lup.xyz/api/users';

export const GAMIFICATION_API =
  'https://gsb.lv02-prod.k8s.gamification-lup.xyz';

export const TOURNAMENT_SS_WIDGETS =
  'https://iframe.a8r.games/widgets/latest/index.js?id={}';

export const TOURNAMENT_LEADERBOARD_WIDGET_URL = 'https://api.lobby.a8r.games';

export const CLIENT_ENVS = {
  CDN_URL: process.env.NEXT_PUBLIC_CDN_URL,
  CDN_URL_2: process.env.NEXT_PUBLIC_CDN_URL_2,
  CMS_S3_URL: process.env.NEXT_PUBLIC_CMS_S3_URL,
  CMS_CDN_URL: process.env.NEXT_PUBLIC_CMS_CDN_URL,
  CDN_ICON_URL: process.env.NEXT_PUBLIC_CDN_ICON_URL,
  APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
  IMG_CDN_URL: process.env.NEXT_PUBLIC_IMG_CDN_URL,
  ANALYTICS_URL: process.env.NEXT_PUBLIC_ANALYTICS_URL,
  CMS_URL: process.env.NEXT_PUBLIC_CMS_URL,
  TOURNAMENT_SS_WIDGETS: process.env.NEXT_PUBLIC_TOURNAMENT_SS_WIDGETS,
  SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  SENTRY_ENVIRONMENT: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
  GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
  GA_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
  CMS_VERSION: process.env.NEXT_PUBLIC_CMS_VERSION,
};

export const EXCLUDED_CDN_DOMAINS = [
  CLIENT_ENVS.CMS_CDN_URL,
  CLIENT_ENVS.CDN_URL,
  CLIENT_ENVS.CDN_URL_2,
  CLIENT_ENVS.CDN_ICON_URL,
  //TODO: After deploy fix images from cms, redownload images in cms
  's3.ap-southeast-2.amazonaws.com',
];

export const PAYMENT_VERIFICATION_ORGANIZATION_IP = '80.232.250.202';
const EE_LICENSE_REGULATOR_IP = '46.22.220.41';

export const WHITELIST_IPS = [
  EE_LICENSE_REGULATOR_IP,
  PAYMENT_VERIFICATION_ORGANIZATION_IP,
];

export const FREESPINS_QUANTITY = 50;
export const BONUSES_QUANTITY = 50;
